<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <div class="div-query-banner">
          <a-form-item label="文件名">
            <j-input v-model="queryParam.busName"></j-input>
          </a-form-item>
          <a-form-item label="文件业务表类型">
            <j-dict-select-tag
              type="list"
              v-model="queryParam.busType"
              dictCode="file_log_bus_type"
              placeholder="请选择业务表类型"
            />
          </a-form-item>
          <a-form-item label="文件操作类型">
            <j-dict-select-tag
              type="list"
              v-model="queryParam.logStatusCode"
              dictCode="file_log_status_code"
              placeholder="请选择文件操作类型"
            />
          </a-form-item>
          <a-button
            type="primary"
            class="query-banner-btn"
            @click="searchQuery"
            icon="search"
            style="margin-left: 21px"
            >查询</a-button
          >
          <a-button
            type="primary"
            class="query-banner-btn"
            @click="searchReset"
            icon="reload"
            style="margin-left: 8px"
            >重置</a-button
          >
        </div>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('bus_common_file_log')">导出</a-button>
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="图片不存在" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <busCommonFileLog-modal ref="modalForm" @ok="modalFormOk"></busCommonFileLog-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import BusCommonFileLogModal from './modules/TechnologyFileBrowseModal'
  import JInput from '@/components/jeecg/JInput.vue'

  export default {
    name: "BusCommonFileLogList",
    mixins:[JeecgListMixin],
    components: {
      BusCommonFileLogModal,JInput
    },
    data () {
      return {
        description: 'bus_common_file_log管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'文件名称',
            align:"center",
            dataIndex: 'busName'
          },
          {
            title:'操作类型',
            align:"center",
            dataIndex: 'logStatusCode_dictText'
          },
          {
            title:'业务表类型',
            align:"center",
            dataIndex: 'busType_dictText'
          },
          {
            title:'操作人',
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title:'操作时间',
            align:"center",
            dataIndex: 'createTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
        ],
        url: {
          list: "/factory/base/busCommonFileLog/list",
          delete: "/factory/base/busCommonFileLog/delete",
          deleteBatch: "/factory/base/busCommonFileLog/deleteBatch",
          exportXlsUrl: "/factory/base/busCommonFileLog/exportXls",
          importExcelUrl: "factory/base/busCommonFileLog/importExcel",
        },
        dictOptions:{},
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';
  .div-query-banner {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin: 20px 0px;
    & > *:nth-child(n) {
      width: 200px;
    }
    & > *:nth-child(n + 2) {
      margin-left: 12px;
    }
    & > .query-banner-btn:nth-child(n) {
      width: 100px;
    }
  }
</style>